import { ActionReducerMapBuilder, createSlice } from "@reduxjs/toolkit";
import { IRequestState } from "../request.state.interface";
import exportBalanceOperationHandler from "./export-balance-operations.handler";

export interface IBalanceOper {
    balance: number;
    operdate: number;
}

export interface IDebugState extends IRequestState {
};

const initialState: IDebugState = {
    loading: false,
    error: "",
};

const debugSlice = createSlice({
    name: 'debugSlice',
    initialState,
    reducers: {},
    extraReducers: (builder: ActionReducerMapBuilder<IDebugState>) => {
        exportBalanceOperationHandler(builder);
    },
});

export default debugSlice.reducer;